<template>
    <div>
        <h3>{{ label }} API token</h3>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <!-- API Token -->
                    <div class="row pb-4">
                        <div class="col-sm-12 col-lg-6">
                            <h4>Token</h4>
                            <div class="sau-bx p-6">
                                {{selectedToken.token ? selectedToken.token : 'This will be generated after you create the token'}}
                            </div>
                        </div>
                    </div>
                    <!-- Selects -->
                    <div class="row mb-1">
                        <div class="col">
                            <b-form-checkbox id="token-enabled"
                                v-model="selectedToken.enabled"
                                value="T"
                                unchecked-value="F">
                            Enable Token
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="row pb-6">
                        <div class="col">
                            <b-form-checkbox id="token-debug-enabled"
                                v-model="selectedToken.debugEnabled"
                                value="T"
                                unchecked-value="F">
                            Debug Enabled
                            </b-form-checkbox>
                        </div>
                    </div>
                    <!-- Permissions -->
                    <div class="row pb-6">
                        <div class="col">
                            <label>Permissions</label>
                            <v-select
                                multiple
                                v-model="permissions"
                                :on-change="permissionsDidChange"
                                :options="displays.permissionOptions"
                            ></v-select>
                            <small class="text-muted">* Required</small>
                        </div>
                    </div>
                    <!-- Allowed Id's -->
                    <div class="row pb-6">
                        <div class="col">
                            <label>Allowed IP's</label>
                            <input-tag :tags.sync="allowedips" :validate="checkIps" :add-tag-on-blur="true"></input-tag>
                            <small class="text-muted">* Only valid IP4 addresses will be accepted</small>
                        </div>
                    </div>
                    <!-- Comments -->
                    <div class="row pb-6">
                        <div class="col col-lg-6">
                            <label>Comments</label>
                            <input v-model="selectedToken.tokenComment" id="tokencomment" class="form-control" maxlength="50" />
                        </div>
                    </div>

                </div>
                <!-- Buttons -->
                <div class="row pt-6">
                    <div class="col-6">
                        <a href="#" @click.prevent="deleteToken(selectedToken.id)" v-if="token" class="btn btn-danger btn-sm">Delete API Token</a>
                    </div>
                    <div class="col-lg-6 float-lg-right">
                        <div class="float-lg-right">
                            <a href="#" @click.prevent="showApiList()">Cancel</a>
                            <button @click.prevent="saveToken()" class="btn btn-sm" :class="btnClass" :disabled="!canSubmit">{{ label }} API token <i v-if="processing" class="far fa-spinner-third fa-spin"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { required, ipAddress } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import InputTag from 'vue-input-tag'
export default {
    props: ['token'],
    components: { vSelect, InputTag },
    data() {
        return {
            label: 'Create',
            processing: false,
            allowedips: [],
            permissions: [],
            selectedToken: {},
            displays:{
                permissionOptions: [
                    {label: 'Modify Master Account Profile', value: 'profile'},
                    {label: 'View & Manage Contacts', value: 'contacts'},
                    {label: 'View Products & Services', value: 'productsview'},
                    {label: 'View & Modify Product Passwords', value: 'productsmanage'},
                    {label: 'View Domains', value: 'domainsview'},
                    {label: 'Manage Domain Settings', value: 'domainsmanage'},
                    {label: 'View & Pay Invoices', value: 'invoices'},
                    {label: 'View & Open Support Tickets', value: 'tickets'},
                    // {label: 'View Emails', value: 'emails'},
                    {label: 'Place New Orders/Upgrades/Cancellations', value: 'orders'}
                ],
            },
            form:{
                enabled: '',
                permissions: '',
            },
        }
    },
    validations: {
        form:{
            permissions: {},
        },
    },
    computed: {
        canSubmit() {
            if(this.allowedips.length == 0 || this.permissions.length == 0 || this.processing) {
                return false;
            }
            return true;
        },
        btnClass() {
            if(this.allowedips.length == 0 || this.permissions.length == 0) {
                return 'btn-light';
            }
            return 'btn-success';
        }
    },
    created() {
        this.startApp();
    },
    methods:{
        startApp() {
            if(this.token) {
                this.setupForm();
            }
        },
        setupForm() {
            // Update the label
            this.label = 'Update';

            // Assign the prop to a new variable - prevent the 'prop mutation' warning
            this.selectedToken = this.token;

            if (typeof this.token.permissions === 'string') {
                this.token.permissions = JSON.parse(this.token.permissions)
            }

            if (typeof this.token.allowedips === 'string') {
                this.allowedips = JSON.parse(this.token.allowedips)
            } else {
                this.allowedips = this.token.allowedips;
            }

            this.setPermissions();
        },
        setPermissions(){
            this.permissions = [];
            for(var index in this.displays.permissionOptions){
                var value = this.displays.permissionOptions[index]['value']
                if(this.selectedToken.permissions.indexOf(value) > -1){
                    this.permissions.push(this.displays.permissionOptions[index])
                }
            }
        },
        updatePermissions(){
            //turn array of selected permissions to comma seperated string
            this.selectedToken.permissions = JSON.stringify(this.permissions.map(function(permission){
                return permission.value
            }))

            this.selectedToken.allowedips = JSON.stringify(this.allowedips);
        },
        permissionsDidChange() {
            let removeDuplicates = function (value, index, values) {
                return values.map((item) => item.value).indexOf(value.value) === index
            }

            let filtered = this.permissions.filter(removeDuplicates)

            if (filtered.length === this.permissions.length) {
                this.updatePermissions()
            } else {
                // This will retrigger this function
                this.permissions = filtered
            }
        },
        checkIps(tagValue) {
            if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(tagValue)) {
                return true;
            }
            return false;
        },
        showApiList(){
            this.$parent.selected = '';
            this.$emit('cancel');
            this.$parent.singleView = false;
            // Trigger jquery to reinitialize the data table
        },
        saveToken(){
            this.processing = true;
            this.updatePermissions()

            if(this.token) {

                // Updating existing token
                this.updateApiToken(this.selectedToken).then(response => {
                    this.$swal({
                        type:'success',
                        title: 'Api Token Saved',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    // Redirect to api index page (reload to fetch latest list)
                    setTimeout(function() {
                        window.location = '/account/api';
                    }, 2000);
                }).catch(error => {
                    this.$swal({
                        type:'error',
                        title: 'There seems to be a problem',
                        html: error.response.data.message || 'There has been a problem updating this API Token.',
                        buttonsStyling: false,
                        confirmButtonText: 'Close',
                        confirmButtonClass: 'btn btn-danger'
                    });
                    this.processing = false;
                });
            } else {
                // Saving new token
                this.saveNewApiToken(this.selectedToken).then(response => {
                    this.$swal({
                        type:'success',
                        title: 'Api Token Created',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    setTimeout(function() {
                        window.location = '/account/api';
                    }, 2000);
                }).catch(error => {
                    this.$swal({
                        type:'error',
                        title: 'There seems to be a problem',
                        html: error.response.data.message || 'There has been a problem saving this API Token.',
                        buttonsStyling: false,
                        confirmButtonText: 'Close',
                        confirmButtonClass: 'btn btn-danger'
                    });
                    this.processing = false;
                });
            }

        },
        deleteToken(){
            this.$swal({
                title: 'Are you sure?',
                text: 'This will delete the API Token',
                type: 'error',
                showCancelButton: true,
                confirmButtonText: 'Delete this API Token',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn btn-link',
                buttonsStyling: false,
                reverseButtons: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            this.deleteApiToken(this.selectedToken.id).then(response => {
                                this.$swal({
                                    type:'success',
                                    title: 'Api Token removed',
                                    showConfirmButton: false,
                                    timer: 3000,

                                });

                                setTimeout(() => {
                                    return window.location.reload();
                                }, 2000);

                            }).catch(error => {
                                this.$swal({
                                    type:'error',
                                    title: 'There seems to be a problem',
                                    html: 'There has been a problem deleting this Api Token.',
                                    buttonsStyling: false,
                                    confirmButtonText: 'Close',
                                    confirmButtonClass: 'btn btn-danger'
                                });
                            });
                        }, 2000)
                    })
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            })
        }
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
